import { useAxios } from "../utils/hooks";
import { useCookies } from "react-cookie";
import { API_BASE_URL, STRIPE_SESSION_COOKIE_NAME } from "../utils/constants";
import { useKeycloak } from "@react-keycloak/web";

export const useStripeCheckout = () => {
  const { keycloak } = useKeycloak();
  const axios = useAxios(API_BASE_URL, keycloak);
  const [, setCookie] = useCookies([STRIPE_SESSION_COOKIE_NAME]);

  const startStripeCheckout = async (duration: string) => {
    duration = duration.toUpperCase();

    if (duration !== "MONTHLY" && duration !== "YEARLY") {
      return;
    }

    axios.current
      ?.post(
        "/purchase/stripe/create-checkout-session",
        JSON.stringify({
          subscriptionDuration: duration,
          purchaseSuccessUrl: undefined,
          purchaseFailureUrl: `${window.location.origin}/settings`,
        }),
      )
      .then((response) => {
        const { sessionId, redirectUrl } = response?.data;
        setCookie(STRIPE_SESSION_COOKIE_NAME, sessionId, { path: "/" });
        window.location.href = redirectUrl;
      })
      .catch((e) => {
        console.error("Failed to start Stripe checkout:", e);
        throw e;
      });
  };

  return { startStripeCheckout };
};
